import Header from "./components/Header.js";
import Caroussel from "./components/Caroussel.js";
import Youtube from "./components/youtube.js";
import Form from "./components/Form.js";
import Chambre from "./components/Chambre.js";
import Formulaire from "./components/Formulaire.js";
import FAQ from "./components/Faq.js";
import Scrolly from "./components/Scrolly.js";
import Cursor from "./components/Cursor.js";


export default class ComponentFactory{
    constructor(){
        this.componentList = {
            Header,
            Caroussel,
            Youtube,
            Form,
            Chambre,
            Formulaire,
            FAQ,
            Scrolly,
            Cursor,

        }

        this.init();

    }

    init(){
        const components = document.querySelectorAll('[data-component]');
        console.log(components);
    
        for (let i = 0; i < components.length; i++) {
            const element = components[i];
            const componentName = element.dataset.component;
            
            if(this.componentList[componentName]){
                new this.componentList[componentName](element);
            } else{
                console.log(`La composante ${componentName} n'exsite pas!`);
            }
        }
    }
}